{
    "NAME": "Idioma da lista de dispositivos",
    "DeviceList_Column_DeviceNumber": "Dispositivo",
    "DeviceList_Column_DeviceNumberInternal": "Extensão",
    "DeviceList_Column_Description": "Descrição",
    "DeviceList_Column_Partition": "Partição",
    "DeviceList_Column_DeviceType": "Tipo de dispositivo",
    "DeviceList_Column_IDOnTelSys": "Conta de recursos",
    "DeviceList_Column_QueueStatus": "Status da fila",
    "DeviceList_Column_Users": "Usuários",
    "DeviceList_Filter_DeviceType": "Tipo de dispositivo",
    "DeviceList_Filter_Partition": "Partição",
    "DeviceList_Add_Disabled_SelectTelephonyServer": "Selecione um servidor de telefonia para adicionar um dispositivo.",
    "DeviceList_Users_MoreUsers": "[{} mais usuários]",
    "DeviceList_Value_None": "Nenhum",
    "DeviceList_Value_All": "Todos"
}